<script lang="ts">
  import { Col, FormGroup, Input, Label, Row } from "sveltestrap";
  import {
    ColorPicker,
    Date,
    DateAndTime,
    Month,
    Time,
    URL,
    Week,
  } from "../../../../utils/Constant/Constant";
</script>

<FormGroup >
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{URL}</Label>
    </Col>
    <Col sm="9">
      <Input type="url" value="https://getbootstrap.com" />
    </Col>
  </Row>
</FormGroup>
<FormGroup>
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{DateAndTime}</Label>
    </Col>
    <Col sm="9">
      <Input
        class="digits"
        id="example-datetime-local-input"
        type="datetime-local"
        value="2018-01-19T18:45:00"
      />
    </Col>
  </Row>
</FormGroup>
<FormGroup >
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{Date}</Label>
    </Col>
    <Col sm="9">
      <Input class="digits" type="date" value="2018-01-01" />
    </Col>
  </Row>
</FormGroup>
<FormGroup>
  <Row>
    <Col sm="3">
    <Label class="col-form-label">{Month}</Label>
    </Col>
    <Col sm="9">
      <Input class="digits" type="month" value="2018-01" />
    </Col>
  </Row>
</FormGroup>
<FormGroup >
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{Week}</Label>
    </Col>
    <Col sm="9">
      <Input class="digits" type="week" value="2018-W09" />
    </Col>
  </Row>
</FormGroup>
<FormGroup>
  <Row>
    <Col sm="3">
      <Label class="col-form-label">{Time}</Label>
    </Col>
    <Col sm="9">
      <Input class="digits" type="time" value="21:45:00" />
    </Col>
  </Row>
</FormGroup>
<FormGroup>
  <Row>
    <Col sm="3">
      <Label class="col-form-label pt-0">{ColorPicker}</Label>
    </Col>
    <Col sm="9">
      <Input class="form-control-color" type="color" value="#563d7c" />
    </Col>
  </Row>  
</FormGroup>
